/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScopeOfCareDto } from '../../models/scope-of-care-dto';
import { UpdateScopeOfCareDto } from '../../models/update-scope-of-care-dto';

export interface UpdateScopeOfCare$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * The entity id
 */
  id: number;
      body: UpdateScopeOfCareDto
}

export function updateScopeOfCare(http: HttpClient, rootUrl: string, params: UpdateScopeOfCare$Params, context?: HttpContext): Observable<StrictHttpResponse<ScopeOfCareDto>> {
  const rb = new RequestBuilder(rootUrl, updateScopeOfCare.PATH, 'put');
  if (params) {
    rb.query('customerId', params.customerId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScopeOfCareDto>;
    })
  );
}

updateScopeOfCare.PATH = '/scopes-of-care/{id}';
